import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'ck-ui';
import { useCountdown } from 'ck-utils/hooks';
import { Timer } from './Timer';

const Countdown = ({ date, hoursToAdd, location, title, titleColor, bgColor, iconBgColor }) => {
  const countdown = useCountdown({ targetDateString: date, hoursToAdd, location });

  if (!countdown) return null;

  return (
    <div className="callout-with-icon" style={{ background: bgColor }}>
      <Icon name="stopwatch" color="secondary" style={{ background: iconBgColor }} />
      <span className="callout">
        <b style={{ color: titleColor }}>{title}: </b>
        <Timer {...countdown} />
      </span>
    </div>
  );
};

Countdown.propTypes = {
  bgColor: PropTypes.string,
  date: PropTypes.string.isRequired,
  hoursToAdd: PropTypes.number,
  iconBgColor: PropTypes.string,
  location: PropTypes.string,
  title: PropTypes.string.isRequired,
  titleColor: PropTypes.string
};

Countdown.defaultProps = {
  bgColor: null,
  hoursToAdd: 0,
  iconBgColor: null,
  location: null,
  titleColor: null
};

export { Countdown };
